import axios from "axios";
import { VesselDTType } from "@/types/apiTypes";
import { API_BASE_URL } from "@/utils/api";

export const fetchVesselDataByTypeAndSizeApi = async (
  vesselType: string,
  vesselSize: string,
): Promise<VesselDTType> => {
  const response = await axios.get<VesselDTType>(`${API_BASE_URL}/vessels`, {
    params: { vessel_type: vesselType, vessel_size: vesselSize },
  });
  return response.data;
};
